// src/services/profitService.js
import api from './api'

const ProfitService = {
  /**
   * Get profit calculation with optional filters
   * @param {Object} filters - Optional filters
   * @param {string} filters.startDate - Start date (YYYY-MM-DD)
   * @param {string} filters.endDate - End date (YYYY-MM-DD)
   * @param {string} filters.branch - Branch ID
   * @returns {Promise} Response with profit data
   */
  getProfitCalculation: async (filters = {}) => {
    try {
      const params = new URLSearchParams()
      
      if (filters.startDate) {
        params.append('startDate', filters.startDate)
      }
      if (filters.endDate) {
        params.append('endDate', filters.endDate)
      }
      if (filters.branch) {
        params.append('branch', filters.branch)
      }

      const queryString = params.toString()
      const url = `/profit-calculation${queryString ? `?${queryString}` : ''}`
      
      const response = await api.get(url)
      return response
    } catch (error) {
      console.error('Error fetching profit calculation:', error)
      throw error
    }
  }
}

export default ProfitService
